import { Input } from '../interfaces';
import { validateEmail } from '../utils/validations';
import { toIllustrations } from './Paths';

export const authInputs: Input[] = [
    {
        name: 'email',
        type: 'text',
        title: 'E-mail',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
    {
        name: 'password',
        type: 'password',
        title: 'Password',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
    {
        name: 'confirmed_password',
        type: 'password',
        title: 'Repeat Password',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
    {
        name: 'new_password',
        type: 'password',
        title: 'New password',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
    {
        name: 'confirmed_new_password',
        type: 'password',
        title: 'Repeat new password',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
];

export const filterInputs: Input[] = [
    {
        name: 'height',
        title: 'Height',
        type: 'range',
        constraints: { min: 140, max: 220 },
    },
    {
        name: 'bust',
        title: 'Bust',
        type: 'range',
        constraints: { min: 30, max: 100 },
    },
    {
        name: 'hips',
        title: 'Hips',
        type: 'range',
        constraints: { min: 30, max: 100 },
    },
    {
        name: 'waist',
        title: 'Waist',
        type: 'range',
        constraints: { min: 30, max: 100 },
    },
    {
        name: 'shoes',
        title: 'Shoes',
        type: 'range',
        constraints: { min: 30, max: 50 },
    },
    {
        name: 'eyes',
        title: 'Eyes',
        fields: [
            {
                name: 'e-amber',
                title: 'Amber',
                type: 'checkbox',
            },
            {
                name: 'e-black',
                title: 'Black',
                type: 'checkbox',
            },
            {
                name: 'e-blue',
                title: 'Blue',
                type: 'checkbox',
            },
            {
                name: 'e-brown',
                title: 'Brown',
                type: 'checkbox',
            },
            {
                name: 'e-grey',
                title: 'Grey',
                type: 'checkbox',
            },
            {
                name: 'e-green',
                title: 'Green',
                type: 'checkbox',
            },
            {
                name: 'e-hazel',
                title: 'Hazel',
                type: 'checkbox',
            },
        ],
    },
    {
        name: 'hair',
        title: 'Hair',
        fields: [
            {
                name: 'h-black',
                title: 'Black',
                type: 'checkbox',
            },
            {
                name: 'h-brown',
                title: 'Brown',
                type: 'checkbox',
            },
            {
                name: 'h-blonde',
                title: 'Blonde',
                type: 'checkbox',
            },
            {
                name: 'h-colored',
                title: 'Colored',
                type: 'checkbox',
            },
            {
                name: 'h-white-gray',
                title: 'White/Gray',
                type: 'checkbox',
            },
            {
                name: 'h-red',
                title: 'Red',
                type: 'checkbox',
            },
        ],
    },
    {
        name: 'categories',
        title: 'Categories',
        fields: [
            {
                name: 'catalog',
                title: 'Catalog',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'look_book',
                title: 'Book',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'campaign',
                title: 'Campaign',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'editorial',
                title: 'Editorial',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'show',
                title: 'Show',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'showroom',
                title: 'Showroom',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'digital',
                title: 'Digital',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'tv_commercial',
                title: 'TV commercial',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'shooting',
                title: 'Shooting',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'fashion_show',
                title: 'Fashion show',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'event',
                title: 'Event',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
            {
                name: 'casting',
                title: 'Casting',
                type: 'range',
                constraints: { min: 0, max: 100 },
            },
        ],
    },
    {
        name: 'place',
        title: 'Place',
        fields: [
            {
                name: 'in_town',
                title: 'In town',
                type: 'checkbox',
            },
            {
                name: 'italy',
                title: 'Italy',
                type: 'checkbox',
            },
            {
                name: 'europe',
                title: 'Europe',
                type: 'checkbox',
            },
            {
                name: 'worldwide',
                title: 'Worldwide',
                type: 'checkbox',
            },
        ],
    },
];

export const editInputs: Input[] = [
    {
        name: 'bio',
        title: 'Personal infromations',
        fields: [
            {
                name: 'name',
                type: 'text',
                title: 'Name',
                placeholder: 'Ex. Karol',
                constraints: {
                    required: true,
                    validate: (value: string) => value.trim() !== '',
                },
            },
            {
                name: 'surname',
                type: 'text',
                title: 'Surname',
                placeholder: 'Ex. Lins',
                constraints: {
                    required: true,
                    validate: (value: string) => value.trim() !== '',
                },
            },
            {
                name: 'birth_date',
                type: 'Date',
                title: 'Birthday',
                constraints: {
                    required: true,
                    validate: (value: string) => value.trim() !== '',
                },
            },
            {
                name: 'nationality',
                type: 'text',
                title: 'Nationality',
                placeholder: 'Ex. Italian',
                constraints: {
                    required: true,
                    validate: (value: string) => value.trim() !== '',
                },
            },
            {
                name: 'place',
                type: 'select',
                title: 'Place',
                constraints: {
                    required: true,
                },
                fields: [
                    {
                        value: 'in_town',
                        name: 'In town',
                    },
                    {
                        value: 'italy',
                        name: 'Italy',
                    },
                    {
                        value: 'europe',
                        name: 'Europe',
                    },
                    {
                        value: 'worldwide',
                        name: 'Worldwide',
                    },
                ],
            },
        ],
    },
    {
        name: 'contacts',
        title: 'Contacts',
        fields: [
            {
                name: 'agency',
                type: 'text',
                title: 'Agency',
                placeholder: 'Ex. Gigi Agency',
                constraints: {
                    /*  required: true,
          validate: (value: string) => value.trim() !== "", */
                },
            },
            {
                name: 'phone',
                type: 'text',
                title: 'Phone',
                placeholder: 'Ex. + 39 3408798654',
                constraints: {
                    /*  required: true,
          validate: (value: string) => value.trim() !== "" */
                    /* &&
            /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
              value
            ), */
                },
            },
            {
                name: 'mail',
                type: 'text',
                title: 'E-mail',
                placeholder: 'Ex. karol.linz@gmail.com',
                constraints: {
                    /*   required: true,
          validate: (value: string) => value.trim() !== "" */
                    /* &&
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value), */
                },
            },
        ],
    },
    {
        name: 'socials',
        title: 'Social',
        fields: [
            {
                name: 'instagram',
                type: 'text',
                title: 'Instagram',
                placeholder: 'Ex.  https://www.instagram.com/XXX',
                iconSrc: `${toIllustrations}/instagram.svg`,
            },
            {
                name: 'facebook',
                type: 'text',
                title: 'Facebook',
                placeholder: 'Ex.  https://www.facebook.com/XXX',
                iconSrc: `${toIllustrations}/facebook.svg`,
            },
            {
                name: 'tiktok',
                type: 'text',
                title: 'Tiktok',
                placeholder: 'Ex.  https://www.tiktok.com/XXX',
                iconSrc: `${toIllustrations}/tiktok.svg`,
            },
        ],
    },
    {
        name: 'mesurements',
        title: 'Mesurements',
        fields: [
            {
                name: 'height',
                type: 'float',
                title: 'Hight',
                placeholder: 'Ex. 170',
                constraints: {
                    required: true,
                    validate: (value: string) => value != '' && /^\d*\.?\d*$/.test(value),
                },
            },
            {
                name: 'bust',
                type: 'float',
                title: 'Bust',
                placeholder: 'Ex. 80',
                constraints: {
                    required: true,
                    validate: (value: string) => value != '' && /^\d*\.?\d*$/.test(value),
                },
            },
            {
                name: 'waist',
                type: 'float',
                title: 'Waist',
                placeholder: 'Ex. 80',
                constraints: {
                    required: true,
                    validate: (value: string) => value != '' && /^\d*\.?\d*$/.test(value),
                },
            },
            {
                name: 'hips',
                type: 'float',
                title: 'Hips',
                placeholder: 'Ex. 60',
                constraints: {
                    required: true,
                    validate: (value: string) => value != '' && /^\d*\.?\d*$/.test(value),
                },
            },
            {
                name: 'shoes',
                type: 'float',
                title: 'Shoes',
                placeholder: 'Ex. 38.5',
                constraints: {
                    required: true,
                    validate: (value: string) => value != '' && /^\d*\.?\d*$/.test(value),
                },
            },
        ],
    },
    {
        name: 'hairs_eyes',
        title: 'Hairs / Eyes',
        fields: [
            {
                name: 'eyes',
                type: 'select',
                title: 'Eyes',
                constraints: {
                    required: true,
                },
                fields: [
                    {
                        name: 'Amber',
                        value: 'amber',
                    },
                    {
                        name: 'Black',
                        value: 'black',
                    },
                    {
                        name: 'Blue',
                        value: 'blue',
                    },
                    {
                        name: 'Brown',
                        value: 'brown',
                    },
                    {
                        name: 'Grey',
                        value: 'grey',
                    },
                    {
                        name: 'Green',
                        value: 'green',
                    },
                    {
                        name: 'Hazel',
                        value: 'hazel',
                    },
                ],
            },
            {
                name: 'hair',
                type: 'select',
                title: 'Hair',
                constraints: {
                    required: true,
                },
                fields: [
                    {
                        name: 'Black',
                        value: 'black',
                    },
                    {
                        name: 'Brown',
                        value: 'brown',
                    },
                    {
                        name: 'Blonde',
                        value: 'blonde',
                    },
                    {
                        name: 'Colored',
                        value: 'colored',
                    },
                    {
                        name: 'White/Gray',
                        value: 'white-gray',
                    },
                    {
                        name: 'Red',
                        value: 'red',
                    },
                ],
            },
        ],
    },
    {
        name: 'skills',
        title: 'Skills',
        fields: [
            {
                name: 'driver_license',
                type: 'skill',
                title: "Driver's license",
            },
            {
                name: 'swim',
                type: 'skill',
                title: 'Swim',
            },
            {
                name: 'ride_bicycle',
                type: 'skill',
                title: 'Ride a bicycle',
            },
            {
                name: 'ski',
                type: 'skill',
                title: 'Ski',
            },
            {
                name: 'ride_horse',
                type: 'skill',
                title: 'Ride a horse',
            },
            {
                name: 'diving',
                type: 'skill',
                title: 'Diving',
            },
        ],
    },
];

export const clientInputs: Input[] = [
    {
        name: 'name',
        type: 'text',
        title: "Client's Name",
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
    {
        name: 'referent_name',
        type: 'text',
        title: "Referent's name",
        /*  constraints: {
      required: true,
      validate: (value: string) => value.trim() !== "",
    }, */
    },
    {
        name: 'location',
        type: 'text',
        title: 'Location',
    },
    {
        name: 'mail',
        type: 'text',
        title: 'E-mail',
        /* constraints: {
      required: true,
      validate: (value: string) => value.trim() !== "",
    }, */
    },
    {
        name: 'phone',
        type: 'text',
        title: 'Phone',
    },
    {
        name: 'mobile',
        type: 'text',
        title: 'Mobile',
    },
    {
        name: 'address',
        type: 'text',
        title: 'Address',
    },
    {
        name: 'website',
        type: 'text',
        title: 'Website',
    },
];

export const settingsInputs: Input[] = [
    {
        name: 'name',
        type: 'text',
        title: 'Name',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
    // {
    //     name: 'ordering',
    //     type: 'text',
    //     title: 'Ordering',
    //     constraints: {
    //         required: true,
    //         validate: (value: string) => value.trim() !== '',
    //     },
    // },
    // {
    //   name: "surname",
    //   type: "text",
    //   title: "Surname",
    //   constraints: {
    //     required: true,
    //     validate: (value: string) => value.trim() !== "",
    //   },
    // },
    {
        name: 'email',
        type: 'text',
        title: 'E-mail',
        constraints: {
            required: true,
            validate: (value: string) => validateEmail(value).isValid,
        },
    },
    {
        name: 'password',
        type: 'password',
        title: 'Password',
    },
    {
        name: 'password_confirmation',
        type: 'password',
        title: 'Confirm Password',
    },
    {
        name: 'cod',
        type: 'text',
        title: 'Cod',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
    {
        name: 'address',
        type: 'text',
        title: 'Address',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
    {
        name: 'phone',
        type: 'text',
        title: 'Phone',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    },
    {
        name: 'description',
        type: 'text',
        title: 'Description',
        constraints: {
            required: true,
            validate: (value: string) => value.trim() !== '',
        },
    }
];
